import { BadgeColor } from '@billy/design-system'
import { useMemo } from 'react'

import { InvoicesSummaryData } from '@features/invoices/types/invoicesSummaryData'

import { InvoicesSummary, InvoiceSummaryItem } from '../../../services/query-api'
import { Stats } from '../types/stats'
import { StatsProps } from '../types/statsProps'

interface UseInvoiceStatsProps {
  summary?: InvoicesSummary
  externalInvoicesSummary?: InvoicesSummaryData
  isExternalInvoicesSource: boolean
}

const getInvoiceStats = (summaryItem: InvoiceSummaryItem | undefined, badgeColor: BadgeColor): StatsProps => ({
  count: summaryItem?.count ?? 0,
  amount: summaryItem?.amount ?? 0,
  badgeColor,
})

export const useInvoiceStats = ({
  summary,
  externalInvoicesSummary,
  isExternalInvoicesSource,
}: UseInvoiceStatsProps): Stats => {
  return useMemo(() => {
    const dataSource = isExternalInvoicesSource ? externalInvoicesSummary : summary

    return {
      overdue: getInvoiceStats(dataSource?.overdue, 'danger'),
      unpaid: getInvoiceStats(dataSource?.unpaid, 'warning'),
      ...(isExternalInvoicesSource
        ? { paid: getInvoiceStats(dataSource?.paid, 'success') }
        : { draft: getInvoiceStats(dataSource?.draft, 'accent') }),
    }
  }, [summary, externalInvoicesSummary, isExternalInvoicesSource])
}
